import FR from './fr'
import EN from './en'

export const TRANSLATIONS = {
    fr: FR,
    en: EN
}
